var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132 0H0V132H132V0Z",
    fill: "url(#paint0_radial_484_3353)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.514 55.6908C111.148 56.757 109.912 57.1819 108.887 56.716C106.548 55.6385 104.103 54.81 101.591 54.2442C96.5097 53.1051 91.9204 53.2486 87.6944 53.3796H87.6852L86.9221 53.4024C82.4318 53.5379 78.3243 53.571 73.9229 52.2052C72.0015 51.6022 70.1535 50.7865 68.4132 49.7733C66.7604 48.8221 65.7933 46.9939 66.0427 45.103C66.2409 43.5769 66.5877 42.0738 67.0782 40.6151C71.2039 28.3312 84.5061 21.7177 96.7922 25.8435C109.078 29.9692 115.689 43.2714 111.564 55.5575L111.514 55.6908Z",
    fill: "url(#paint1_radial_484_3353)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M65.2955 52.4649C63.76 51.5024 61.6322 52.7861 61.9489 54.5699L70.3371 101.931C70.3679 102.104 70.4446 102.265 70.5593 102.398C70.674 102.531 70.8223 102.631 70.9888 102.687C71.1553 102.743 71.3338 102.753 71.5055 102.716C71.6773 102.679 71.8359 102.597 71.9648 102.477L110.902 66.3924C112.283 65.1121 112.12 62.8727 110.486 61.9352C106.935 59.8951 103.718 58.7242 100.729 58.0544C96.143 57.0292 92.0047 57.1545 87.7103 57.2866L87.0269 57.3072C82.5321 57.4427 77.8368 57.5145 72.7519 55.9403C70.1255 55.1121 67.6187 53.9437 65.2955 52.4649Z",
    fill: "url(#paint2_linear_484_3353)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9516 58.1045C86.0278 57.8778 86.1715 57.6798 86.3636 57.5373C86.5556 57.3947 86.7867 57.3144 87.0257 57.3071L87.7091 57.2866C92.0035 57.1545 96.1383 57.0281 100.728 58.0544C103.717 58.7241 106.933 59.8951 110.485 61.9352C112.119 62.8727 112.281 65.1121 110.901 66.3924L71.9636 102.477C71.8336 102.599 71.6728 102.682 71.4987 102.718C71.3246 102.755 71.1438 102.743 70.9761 102.683L85.9516 58.1045Z",
    fill: "url(#paint3_linear_484_3353)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.438 49.0943C107.979 53.4399 99.428 51.6254 89.2766 48.2138C79.1251 44.8023 71.2085 41.0877 72.6676 36.7433C74.1268 32.3988 79.9076 27.56 94.5607 32.4809C109.214 37.4017 110.899 44.7499 109.438 49.0943Z",
    fill: "#101622"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5596 32.4831C87.0861 29.9771 81.9215 30.0033 78.4609 31.2096C78.699 38.363 85.4412 45.8513 95.3399 49.1763C99.8552 50.6936 104.37 51.1219 108.373 50.6127C108.874 50.2264 109.246 49.698 109.441 49.0966C110.899 44.7499 109.21 37.4028 94.5596 32.4831Z",
    fill: "#212C3D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M104.386 40.2653C105.639 41.5183 107.534 44.3022 105.932 45.4857C104.298 46.6954 96.9163 40.7506 97.389 38.4132C97.8037 36.4027 100.871 36.7341 104.386 40.2653Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7545 36.5438L86.8141 36.2278C86.4384 36.1016 86.0315 36.3038 85.9053 36.6795L84.7923 39.9923C84.6661 40.368 84.8684 40.7749 85.2441 40.9011L86.1845 41.2171C86.5602 41.3433 86.9671 41.141 87.0933 40.7653L88.2063 37.4525C88.3325 37.0768 88.1302 36.67 87.7545 36.5438Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2962 40.4209L98.3557 40.105C97.98 39.9787 97.5731 40.1809 97.4469 40.5566L96.334 43.8694C96.2077 44.2451 96.41 44.652 96.7857 44.7782L97.7262 45.0942C98.1019 45.2204 98.5087 45.0181 98.635 44.6424L99.7479 41.3297C99.8741 40.954 99.6719 40.5471 99.2962 40.4209Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5841 87.5679L20.2916 104.866C14.2795 106.366 8.90077 100.796 10.6026 94.8421L30.2688 26.1829C31.9774 20.2255 39.4953 18.3494 43.7976 22.8055L93.4205 74.1632C97.7296 78.6159 95.5973 86.0666 89.5841 87.5679Z",
    fill: "url(#paint4_linear_484_3353)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7699 34.9012L37.6477 35.9305C35.5646 36.4507 34.2975 38.5611 34.8177 40.6442L41.5976 67.7966C42.1178 69.8798 44.2281 71.1468 46.3113 70.6267L50.4335 69.5973C52.5167 69.0772 53.7837 66.9668 53.2636 64.8836L46.4836 37.7313C45.9635 35.6481 43.8531 34.3811 41.7699 34.9012Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3236 87.7547C54.644 87.7547 57.3356 85.063 57.3356 81.7427C57.3356 78.4223 54.644 75.7306 51.3236 75.7306C48.0032 75.7306 45.3115 78.4223 45.3115 81.7427C45.3115 85.063 48.0032 87.7547 51.3236 87.7547Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_484_3353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.0006 66.0006) scale(66.0006)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF47CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#B9065C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_484_3353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.51 36.8012) rotate(-174.134) scale(90.0063 107.843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_484_3353",
    x1: 89.616,
    y1: 51.8524,
    x2: 73.3882,
    y2: 100.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_484_3353",
    x1: 101.47,
    y1: 54.5355,
    x2: 77.9162,
    y2: 124.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_484_3353",
    x1: 25.7064,
    y1: 17.8631,
    x2: 57.2405,
    y2: 99.5307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6170"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#991919"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundImage);
export default __webpack_public_path__ + "static/media/BackgroundImage.c59225e4.svg";
export { ForwardRef as ReactComponent };